import { createTheme } from '@mui/material/styles';

export const cabieTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#00857d',
    },
    secondary: {
      main: '#ffbe00',
    },
    background: {
      paper: '#f0f4f9',
    },
  },
  typography: {
    h1: { fontFamily: 'Georgia, serif' },
    h2: { fontFamily: 'Georgia, serif' },
    h3: { fontFamily: 'Georgia, serif' },
    h4: { fontFamily: 'Georgia, serif' },
    h5: { fontFamily: 'Georgia, serif' },
    h6: { fontFamily: 'Georgia, serif' },
  },
});
